import {Component} from '@angular/core';
import { BookDemoService } from '../../../dialogs/book-demo-dialog/book-demo.service';

@Component({
  selector: 'app-ts-v2-steps-section',
  templateUrl: './steps-section.component.html',
  styleUrls: ['./steps-section.component.scss'],
})
export class V2StepsSectionComponent {
  steps = [
    {
      titleKey: 'talentSearchV2.steps.step1Title',
      imageName: 'step-1',
    },
    {
      titleKey: 'talentSearchV2.steps.step2Title',
      imageName: 'step-2',
    },
    {
      titleKey: 'talentSearchV2.steps.step3Title',
      imageName: 'step-3',
    },
  ];

  constructor(private bookDemo: BookDemoService) {}

  openBookDemo(): void {
    this.bookDemo.open();
  }
}
